import PropTypes from 'prop-types';

/**
 * AttributeContent component - Displays attribute name-value pairs
 * In the grid layout, name is displayed in the title (handled by AMFIItem)
 * and value is displayed in the content
 */

// TODO: use formatName and remove linter disable line, or remove it
// eslint-disable-next-line no-unused-vars
const AttributeContent = ({ item, formatName }) => {
	return (
		<div className='attribute-content'>
			<div
				className='attribute-value'
				style={{
					fontSize: '0.95rem',
					fontWeight: '500',
					color: '#333',
					wordBreak: 'break-word',
				}}
			>
				{item.value}
			</div>
		</div>
	);
};

AttributeContent.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		category: PropTypes.string,
		is_key: PropTypes.bool,
		source: PropTypes.string,
	}).isRequired,
	formatName: PropTypes.func.isRequired,
};

export default AttributeContent;
